import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Arrow = styled.i`
  border: solid ${props => props.color};
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: ${props => props.size}px;
  transition: transform .3s ease-in-out;
  transform-origin: center;
  ${props =>
    props.position === 'right' &&
    `
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  `}
  ${props =>
    props.position === 'left' &&
    `
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
  `}
  ${props =>
    props.position === 'up' &&
    `
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
  `}
  ${props =>
    props.position === 'down' &&
    `
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
  `}
  ${props =>
    props.cssPosition &&
    `
    position: ${props.cssPosition};
    top: ${props.top};
    right: ${props.right};
    bottom: ${props.left};
    left: ${props.bottom};
  `}
`;

const ArrowComponent = props => {
  return (
    <Arrow
      color={props.color}
      position={props.position}
      size={props.size}
      top={props.top}
      right={props.right}
      left={props.left}
      bottom={props.bottom}
      cssPosition={props.cssPosition}
    />
  );
};

ArrowComponent.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  position: PropTypes.string,
  cssPosition: PropTypes.string,
  top: PropTypes.string,
  right: PropTypes.string,
  left: PropTypes.string,
  bottom: PropTypes.string,
};

ArrowComponent.defaulProps = {
  top: 'unset',
  right: 'unset',
  bottom: 'unset',
  left: 'unset',
  cssPosition: null,
};

export default ArrowComponent;



// WEBPACK FOOTER //
// ./src/components/Icons/Arrow/index.js